export default __webpack_public_path__ + "static/media/4.94ab899b.jpg";